<script context="module">

  export function load(src) {
    
  }
</script>

<script>
  export let zIndex;

  let audio;
  let paused = true;
  let progressPosition = 0
  let position = 0
  let scrubPosition = 0
  let scrubbing = false
  let touchListener = null
  let asideElem = null
  let windowTouchId = false

  let screenWidth = 0
  let screenHeight = 0

  import { styleVars } from '/helper'
  import { useLocation } from "svelte-navigator";

  import { audioPlayer } from '/stores.js';
  import { secondsToHMS, fixUrl } from '/helper'

  import Link from '/components/Atoms/Link'
  import IconPlayPause from '/components/Icons/IconPlayPause'
  import IconInfo from '/components/Icons/IconInfo'
  import IconClose from '/components/Icons/IconClose'

  const location = useLocation();

  let audioSrc

  $: {
    if (audioSrc != $audioPlayer.src) {
      console.log("reset track!")
      scrubbing = false
      scrubPosition = 0
    }

    audioSrc = $audioPlayer.src

    //console.log(position, $audioPlayer)
    
    if (!$audioPlayer.paused){
      //$audioPlayer.position = position
    }
    progressPosition = scrubbing ? scrubPosition : position / ($audioPlayer.duration)

    // debounce
    if (audio && $audioPlayer.src && !$audioPlayer.paused && audio.paused ) {
      var playPromise = audio.play()
      //console.log(playPromise)
        playPromise.then(function(result) {
            console.log("play result",result)
          }).catch(function(error) {
            console.warn(error)
          });
        }
    if (audio && $audioPlayer.paused  && !audio.paused ) audio.pause()
  }

  const autoplay = () => {
    if ($audioPlayer.paused && position < 1) audio.play()
  }

  const startScrubbing = event => {
    //console.log("down", event?.targetTouches?.[0].identifier)
    // in case the touch was started somewhere else, don't act
    if (windowTouchId === false && event?.targetTouches?.[0].identifier === windowTouchId) {
      //windowTouchId = false
      //return
    }
    if (asideElem == event.target && scrubbing == false) { 
      scrubbing = true
      handleMousemove(event)
      console.log("start")
      touchListener = event.target.addEventListener("touchmove", event=>handleMousemove(event))
    }
  }

  const handleMousemove = event => {
    const x = event.clientX || event?.targetTouches?.[0]?.clientX
    const y = event.clientY || event?.targetTouches?.[0]?.clientY
    scrubPosition = x/screenWidth
    //console.log("move", event, x, y, scrubPosition, scrubbing)
    if (y < screenHeight * 0.6) {
      console.log(x, screenHeight)
      cancelScrubbing()
    }
    //console.log(scrubPosition, event.clientX, screenWidth)
  }

  const cancelScrubbing = () => {
    console.log("cancelScrubbing")
    if (touchListener) removeEventListener(touchListener)
    scrubbing = false
  }

  const finishScrubbing = () => {
    if (scrubbing) {
      console.log("finishScrubbing")
      position = scrubPosition * $audioPlayer.duration
      if (touchListener) removeEventListener(touchListener)
      scrubbing = false
    }
  }

  // ATTN: canplay event fires continuously on chrome

</script>

<svelte:window 
  bind:innerWidth={screenWidth} 
  bind:innerHeight={screenHeight}
  on:touchstart={ event => {windowTouchId = event.touches[0].identifier; console.log(windowTouchId)}}
/>

<aside 
    bind:this={asideElem}
    class:playing={!paused} 
    class:loaded={!!$audioPlayer.src} 
    on:mousedown={ startScrubbing }
    on:touchstart={ startScrubbing }
    on:touchend={ finishScrubbing }
    on:mouseup={ finishScrubbing }
    on:mouseleave={ cancelScrubbing }
    on:mousemove={ handleMousemove }
    style={ styleVars({zIndex, percentage: -progressPosition*100+"%"}) }
  >

  <div class="icon icon-playpause" on:click={audioPlayer.togglePlay}>
    <IconPlayPause mint transparent paused={$audioPlayer.paused} />
  </div>

  <h2 class="title">{$audioPlayer.title}</h2>

  {#if $location.pathname !== $audioPlayer.pagePath}
    <Link to={$audioPlayer.pagePath}>
      <span class="icon icon-info">
        <IconInfo />
      </span>
    </Link>
  {/if}
  
  <div class="duration">
    {secondsToHMS($audioPlayer.duration)}
  </div>

  <div class="icon icon-close" on:click={ ()=> {audio.pause(); audioPlayer.reset() } }>
    <IconClose />
  </div>

</aside>

<audio
  autoplay
  bind:this={audio}
  bind:paused={$audioPlayer.paused}
  bind:currentTime={position}
  bind:duration={$audioPlayer.duration}
  on:canplay={ autoplay }
  src={ audioSrc }
/>

<style lang="scss">
  aside { 
    position: fixed;
    z-index: var(--zIndex);
    bottom: 0;
    height: $audioplayer-height;
    background-color: $color-red;

    background: linear-gradient(90deg, $color-red 50%, $color-mint 50%);
    background-position-x: var(--percentage);
    background-size: 200% 200%;

    display: flex;
    place-items: center;
    width: 100%;

    @include typo-grotesk-title-captions-20;
    
    transition: transform 0.2s ease-out;
    user-select: none;

    &:not(.loaded) {
      transform: translateY(120%);
    }
  }
  .icon {
    cursor: pointer;
    display: flex;
    place-items: center;
    :not(.loaded) & {
      visibility: hidden;
    }
  }

  .scrub-overlay {
    background: #7935;
    width: 100%;
    height: 100vh;
    position: absolute;
    left:0;
    bottom:0;
    z-index: 1;
  }

  .icon-info {
    padding: 0 20px;
  }

  .icon-close {
    padding: 0 10px;
  }

  .title {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .title, .duration {
    pointer-events: none;
    position: relative;
    top: 0.2ex;
    left: 0.2ex;
  }

  .title, .duration, .icon {
    color: $color-mint;
    mix-blend-mode: difference;
  }

  audio { position: fixed; bottom: 150px; }

</style>